import { useQuery } from '@tanstack/react-query';
import ClientManagerService from '../services/ClientManager/clientManager.service';

/**
 * The full client record. Shared by the expanded add-on row and the edit wizard,
 * so opening one after the other reuses a single fetch.
 */
export const useClientDetails = (clientId: number | undefined, enabled: boolean) => {
  const { getClientDetails } = ClientManagerService();
  const { data, isLoading, isSuccess, isLoadingError, error } = useQuery({
    ...getClientDetails(clientId as number),
    enabled: enabled && !!clientId,
  });

  return {
    clientDetails: data,
    hasClientDetails: isSuccess,
    isLoadingClientDetails: isLoading,
    isClientDetailsLoadingError: isLoadingError,
    clientDetailsError: error,
  };
};
